import { axiosInstance } from 'api/axios';
import { routes } from 'api/routes';

export const deleteFilesFromServer = async (id: string) => {
  return axiosInstance.delete(`${routes['files']}/${id}`);
};
